/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboResponseResp
 */
export interface JumboResponseResp {
    /**
     * 
     * @type {string}
     * @memberof JumboResponseResp
     */
    message?: string;
}

/**
 * Check if a given object implements the JumboResponseResp interface.
 */
export function instanceOfJumboResponseResp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboResponseRespFromJSON(json: any): JumboResponseResp {
    return JumboResponseRespFromJSONTyped(json, false);
}

export function JumboResponseRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboResponseResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JumboResponseRespToJSON(value?: JumboResponseResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

